import { render, staticRenderFns } from "./CaptchaVerificationCode.vue?vue&type=template&id=2e1d5f34&scoped=true"
import script from "./CaptchaVerificationCode.vue?vue&type=script&lang=js"
export * from "./CaptchaVerificationCode.vue?vue&type=script&lang=js"
import style0 from "./CaptchaVerificationCode.vue?vue&type=style&index=0&id=2e1d5f34&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1d5f34",
  null
  
)

export default component.exports